import React, { FC } from 'react';
import { Box } from '@bechtel/gds';
import { UnderConstruction } from '@bechtel/client-common';

export const Timeline: FC = () => {
  return (
    <Box
      justifyContent={{ sm: 'center' }}
      alignItems={{ sm: 'center' }}
      flexGrow={{ sm: '1' }}
      css="height: 100%;"
      data-testid="timeline-container"
    >
      <UnderConstruction />
    </Box>
  );
};
